import React, { useMemo } from 'react'
import MealIngredientPreparationForm from './_form'

export default function MealIngredientPreparationAdd (props) {
  const data = useMemo(() => ({ active: false }), [])
  return (
    <MealIngredientPreparationForm data={data} {...props} />
  )
}